import { WorkerActionData } from '@/hooks/useSecWorker';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import {
    getHostByGameId,
    hostsSliceActions,
} from '../../../modules/host/slice';
import store from '../../../store/store';
import { GameState } from '../../games/enums/GameState';
import { GameType as GameTypeEnum } from '../../games/enums/GameType';
import { CMDScRestart, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScRestartHandler extends AbstractHandler {
    _command: CMDScRestart;
    _registWorkerAction: (item: WorkerActionData) => void;
    constructor(
        command: ICommand,
        registWorkerAction: (item: WorkerActionData) => void
    ) {
        super();
        this._command = command as CMDScRestart;
        this._registWorkerAction = registWorkerAction;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const gameId = this._command.GameID;
        const state = store.getState();
        const host = getHostByGameId(state, gameId);
        const restartTimes: number = host.IsRestart ? host.IsRestart + 1 : 1;

        if (host) {
            switch (host.GameType) {
                case GameTypeEnum.SeDie:
                case GameTypeEnum.SicBo:
                case GameTypeEnum.Roulette:
                case GameTypeEnum.UltraRoulette:
                case GameTypeEnum.ThaiHiLo:
                case GameTypeEnum.FishPrawnCrab:
                case GameTypeEnum.CarnivalTreasure:
                    batch(() => {
                        dispatch(
                            hostLiveSliceActions.updateGameState({
                                hostId: host.HostId,
                                state: GameState.Restart,
                            })
                        );
                        dispatch(
                            hostsSliceActions.updateIsRestart({
                                hostId: host.HostId,
                                isRestart: restartTimes,
                            })
                        );
                    });
                    this._registWorkerAction({
                        key: host.HostId.toString(),
                        time: 2,
                        callbackFunc: () => {
                            dispatch(
                                hostsSliceActions.updateIsRestart({
                                    hostId: host.HostId,
                                    isRestart: 0,
                                })
                            );
                        },
                    });
                    // dispatch(
                    //     popupSliceActions.open(
                    //         'sedie.reshake',
                    //         undefined,
                    //         POPUP_TYPE.POPUP,
                    //         2000
                    //     )
                    // );
                    //     break;
                    // case GameTypeEnum.Roulette:
                    // dispatch(
                    //     popupSliceActions.open(
                    //         'roulette.respin',
                    //         undefined,
                    //         POPUP_TYPE.POPUP,
                    //         2000
                    //     )
                    // );
                    break;
            }
        }
    }
}
